import React from "react";
// @ts-ignore
import { AppRegistry } from "react-native-web";
import { ApolloProvider } from "@apollo/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import tvgConf from "@tvg/conf";
import ApolloContext from "@tvg/utils/apolloContext";
import { TVGThemeProviderWeb, TvgConfProvider } from "@tvg/design-system";
import { FormationTokens } from "@tvg/design-system/web";
import RaceTracks from "@tvg/gtm/src/modules/RaceTracks";
import ApolloClient from "./apolloClient/ApolloClient";
import configureStore from "./store/configureStore";
import Main from "./pages";

const preloadedState = window.__RACETRACKS_PRELOADED_STATE__; // eslint-disable-line no-underscore-dangle

// GTM subscribers event init
RaceTracks();

const store = configureStore(preloadedState);
// gets conf for specific host / device
tvgConf(window.location.hostname, window.navigator.userAgent);

const App = () => {
  const apolloClient = ApolloClient.createClient(false);
  return (
    <TvgConfProvider>
      <TVGThemeProviderWeb isFanduelTheme={false}>
        <FormationTokens />
        <ApolloProvider client={apolloClient}>
          <ApolloContext.Provider
            value={{
              fcpClient: apolloClient,
              rdaClient: ApolloClient.createClient(false, "rda")
            }}
          >
            <Provider store={store}>
              <BrowserRouter>
                <Main />
              </BrowserRouter>
            </Provider>
          </ApolloContext.Provider>
        </ApolloProvider>
      </TVGThemeProviderWeb>
    </TvgConfProvider>
  );
};

const Render = () => {
  if (document.getElementById("racetracks")) {
    AppRegistry.registerComponent("App", () => App);

    AppRegistry.runApplication("App", {
      initialProps: {},
      rootTag: document.getElementById("racetracks")
    });
  }
};

export default Render();
